import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import styles from "./CartPanel.module.css";
import { useDispatch, useSelector } from "react-redux";
import { removeItemFromCart } from "../../store/slices/cartSlice";
import diamondDummy from "../../assets/diamonds/diamond_round.png";
import {
  useGetCartItemsQuery,
  useRemoveItemFromCartMutation,
  useSendInquiryMutation,
} from "../../store/api/cartApi";
import Loader from "../common/Loader";
import InlineLoaderComponent from "../common/InlineLoaderComponent";
import { toast } from "sonner";
import { openInquiryModel } from "../../store/slices/commonSlice";
import { useNavigate } from "react-router-dom";

const CartPanel = ({ open, onClose, cartItems }) => {
  const authData = useSelector((state) => state?.auth);
  const panelRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [
    removeFromCart,
    { data: removedFromCart, isLoading: removingFromCart },
  ] = useRemoveItemFromCartMutation();

  const [sendInquiry, { data: inquirySendData, isLoading: sendingInquiry }] =
    useSendInquiryMutation();
  // const { cartItem } = useSelector((state) => state?.cart);
  const { data: cartItem } = useGetCartItemsQuery(null, {
    skip: !authData?.token,
  });
  useEffect(() => {
    if (!open) return;
    function handleClickOutside(e) {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        onClose();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, onClose]);

  if (!open) return null;

  const handleRemoveCartItem = (cartItem) => {
    removeFromCart({
      inventoryId: cartItem?.inventory_id,
    });
  };

  // Render the overlay and panel using a portal
  return ReactDOM.createPortal(
    <div className={styles.overlay}>
      <aside className={styles.cartPanel} ref={panelRef}>
        {removingFromCart && <Loader />}
        <div className={styles.header}>
          <h2>Cart</h2>
          <button
            className={styles.closeBtn}
            onClick={onClose}
            aria-label="Close cart"
          >
            &times;
          </button>
        </div>
        <div className={styles.cartItems}>
          {cartItem?.length === 0 ? (
            <div className={styles.empty}>Your cart is empty.</div>
          ) : (
            cartItem?.map((item, idx) => (
              <div className={styles.cartItem} key={idx}>
                <img
                  src={item.image_url || diamondDummy}
                  alt={item.title}
                  className={styles.itemImage}
                />
                <div className={styles.itemDetails}>
                  <div className={styles.itemDesc}>
                    {" "}
                    {item?.shape} {item?.carat}ct {item?.color} {item?.clarity}
                  </div>
                  <div className={styles.itemTitle}>
                    {item.certificate_number}
                  </div>

                  <div className={styles.itemPrice}>
                    ${item.total_price?.toFixed(2)}
                  </div>
                </div>
                <button
                  className={styles.removeBtn}
                  onClick={() => handleRemoveCartItem(item)}
                  aria-label="Remove item"
                >
                  &times;
                </button>
              </div>
            ))
          )}
        </div>
        <button
          className={styles.checkoutBtn}
          onClick={() => {
            if (!authData?.token) {
              navigate("/login");
              onClose();
              return;
            }
            if (cartItem?.length > 0) {
              sendInquiry()
                .unwrap()
                .then((data) => {
                  onClose();
                  setTimeout(() => {
                    dispatch(openInquiryModel(true));
                    toast.success(data?.message);
                  }, 100);
                });
            }
          }}
        >
          {!authData?.token ? "Login To Add Items" : "Send Inquiry"}{" "}
          {sendingInquiry && <InlineLoaderComponent />}
        </button>
      </aside>
    </div>,
    document.body
  );
};

export default CartPanel;
